import { Provider } from '@angular/core';

import { TASK_MAPPERS } from '../contracts/task-mapper.contract';
import { CheckPlannedAppointmentTaskMapper } from '../mappers/check-planned-appointment.mapper';
import { HealthCheckInTaskMapper } from '../mappers/health-check-in.mapper';
import { ManualAppointmentCancellationTaskMapper } from '../mappers/manual-appointment-cancellation.mapper';
import { OrphanedOfferingTaskMapper } from '../mappers/orphaned-offering.mapper';
import { ProcessGuaranteeApplicationTaskMapper } from '../mappers/process-guarantee-application.mapper';
import { ServiceRequestTaskMapper } from '../mappers/service-request.mapper';
import { TaskMapperRegistry } from '../services/task-mapper-registry.service';

export function provideTaskMappers(): Provider[] {
  return [
    TaskMapperRegistry,
    { provide: TASK_MAPPERS, useClass: ProcessGuaranteeApplicationTaskMapper, multi: true },
    { provide: TASK_MAPPERS, useClass: ServiceRequestTaskMapper, multi: true },
    { provide: TASK_MAPPERS, useClass: ManualAppointmentCancellationTaskMapper, multi: true },
    { provide: TASK_MAPPERS, useClass: CheckPlannedAppointmentTaskMapper, multi: true },
    { provide: TASK_MAPPERS, useClass: OrphanedOfferingTaskMapper, multi: true },
    { provide: TASK_MAPPERS, useClass: HealthCheckInTaskMapper, multi: true },
  ];
}
